module.exports = __webpack_public_path__ + "img/logo_navbar.ca399b01.png";